module.exports = __webpack_public_path__ + "static/media/loi-luu-200x200.9a197e7f.jpg";